module.exports = __webpack_public_path__ + "static/media/AvailableOutputs.17c41a57.svg";